import { render, staticRenderFns } from "./CustomerFormAnswerAnalysis.vue?vue&type=template&id=2b8a7e4d&"
import script from "./CustomerFormAnswerAnalysis.vue?vue&type=script&lang=js&"
export * from "./CustomerFormAnswerAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFormAnswerAnalysis.vue?vue&type=style&index=0&id=2b8a7e4d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports